module.exports = __webpack_public_path__ + "static/media/flight-departure.e06ed360.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/flight-departure.svg
// module id = 700
// module chunks = 0